import { render, staticRenderFns } from "./BenchmarkMetrics.vue?vue&type=template&id=091bf051&scoped=true&"
import script from "./BenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BenchmarkMetrics.vue?vue&type=style&index=0&id=091bf051&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091bf051",
  null
  
)

export default component.exports